// Tokens do design system do SigepeWeb.
// Paleta do ERP desktop (navy + amarelo), a mesma do app tifiregerencial (theme/tokens.js).
// Nenhuma cor fora deste arquivo: use sempre `theme.cores.*` nos styled-components.

const cores = {
  // Marca
  primary: '#2c3e50',
  primaryHover: '#34495e',
  primarySoft: '#3d566e',
  accent: '#ffcb00',

  // Superfícies
  surface: '#f4f6f8',
  surfaceHover: '#eaedf1',
  card: '#ffffff',
  border: '#d9dde2',
  borderStrong: '#b8bfc8',

  // Texto
  ink: '#1f2933',
  inkSecondary: '#52606d',
  inkMuted: '#7b8794',
  inkInverse: '#ffffff',
  // Texto secundário e divisórias sobre o navy (header, sidebar, menu mobile)
  inkInverseMuted: 'rgba(255, 255, 255, 0.68)',
  borderInverse: 'rgba(255, 255, 255, 0.14)',

  // Status
  good: '#0f7b4a',
  goodSoft: '#e3f4ec',
  critical: '#c62828',
  criticalHover: '#a51f1f',
  criticalSoft: '#fdecea',
  warning: '#b26a00',
  warningSoft: '#fff4e0',

  // Linha selecionada / foco
  selecionado: '#e6ebf0',
  foco: 'rgba(44, 62, 80, 0.25)',
  overlay: 'rgba(15, 23, 32, 0.5)',

  // Landing page (Home): botão do WhatsApp e texto sobre o navy do hero
  whatsapp: '#0e7d43',
  whatsappHover: '#0b6636',
  heroDestaque: 'rgba(255, 203, 0, 0.14)',

  // Gráficos (mesma paleta do app tifiregerencial, validada pela skill dataviz).
  // Séries sempre nesta ordem, sem ciclar: com mais de 8, o resto vira "Outros".
  serie: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
  poloNegativo: '#e34948',
  grade: '#e6e8eb',
};

export const theme = {
  cores,
  raio: {
    sm: '6px',
    md: '8px',
    card: '12px',
    pill: '999px',
  },
  espaco: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  fonte: {
    caption: '12px',
    small: '13px',
    body: '14px',
    input: '15px',
    h3: '16px',
    h2: '20px',
    h1: '24px',
  },
  sombra: {
    card: '0 1px 2px rgba(15, 23, 32, 0.06)',
    dropdown: '0 8px 24px rgba(15, 23, 32, 0.16)',
    modal: '0 16px 48px rgba(15, 23, 32, 0.24)',
  },
  alturaControle: {
    sm: '32px',
    md: '40px',
    mobile: '44px',
  },
  layout: {
    alturaHeader: '56px',
    larguraSidebar: '250px',
  },
  zIndex: {
    sidebar: 10,
    header: 20,
    dropdown: 30,
    drawer: 40,
    modal: 50,
  },
  breakpoints: {
    mobile: 768,
  },
};

export type Theme = typeof theme;

// Uso: ${media.mobile} { ... }
export const media = {
  mobile: `@media (max-width: ${theme.breakpoints.mobile - 1}px)`,
  desktop: `@media (min-width: ${theme.breakpoints.mobile}px)`,
};
